import $ from "jquery";

<template>
    <form :id="sectionname">
        <div :class="isOpen?'section-header section-opened':'section-header section-closed'">
            <h4 class="subtitle">
                <div class="d-flex align-items-center">
                    <span class="checkout-section">{{sectionindex}}</span>
                    <slot name="title"></slot>
                </div>
                <div>
                    <slot name="action-open" v-if="isOpen"></slot>
                    <slot name="action-closed" v-if="!isOpen"></slot>
                </div>
            </h4>
            <div class="section-action-wrapper">
                <slot name="action-open" v-if="isOpen"></slot>
                <slot name="action-closed" v-if="!isOpen"></slot>
            </div>
        </div>
        <div class="section-body" v-bind:class="{ open: isOpen }" ref="sectionBody">
            <slot></slot>
        </div>
    </form>
</template>

<script>
    export default {
        data: function () {
            return {
            };
        },
        props: ["sectionname", "sectionindex", "currentsection"],
        mounted: function () {
            var vm = this;
            vm.toggleAnimation(false);
        },
        methods: {
            toggleAnimation: function (animate) {
                var vm = this;
                var el = $(vm.$refs.sectionBody);
                if (vm.sectionname == vm.currentsection) {
                    var height = el.children().height();
                    el.animate({ "height": height }, animate ? 300 : 0, "swing", function () {
                        $(this).css({ "overflow": "visible", "height": "auto" });
                    });
                } else {
                    el.css({ "overflow": "hidden" }).animate({ "height": 0 }, animate ? 300 : 0, "swing");
                }
            },
        },
        computed: {
            isOpen: function () {
                if (this.sectionname == this.currentsection) {
                    return true;
                }
                return false;
            },
        },
        watch: {
            currentsection: function (val) {
                var vm = this;
                vm.toggleAnimation(true);

            },
        }
    }
</script>